<div class="mt-4">
  <div
    class="flex items-center justify-between grow border border-gray-200 rounded-xl gap-2 p-5 [background-position:220%_44%] bg-no-repeat bg-[length:650px] user-access-bg"
  >
    <div class="flex items-center gap-4">
      <div class="flex flex-col gap-1.5">
        <div class="flex items-center gap-2.5">
          <a
            class="text-base font-semibold text-gray-900 hover:text-primary-active"
          >
            {{ fields.displayName }}
          </a>
        </div>
        <div class="form-info">
          {{ fields.helpText }}
        </div>
      </div>
    </div>
    <div class="flex items-center gap-1.5 relative">
      <!-- Background behind the button -->
      <div class="relative">
        <div
          style="
            background-image: url(&quot;./assets/media/icons/effects.png&quot;);
            background-repeat: no-repeat;
          "
          class="absolute inset-0 bg-center rounded-md z-0"
        ></div>
        <button
          class="btn btn-sm btn-dark relative z-10"
          *ngIf="fields.properties.buttonProperty.text"
          [ngStyle]="fields.properties.buttonProperty.style"
        >
          {{ fields.properties.buttonProperty.text }}
        </button>
      </div>
    </div>
  </div>
</div>
